import React from 'react';
import {Row, Col, Typography} from 'antd';
import {Dinheiro, Impressao} from '@contentsys/contentsys-react-components';
import moment from 'moment';

const LayoutImpressaoDevolucao = ({devolucao, setOpenEvent}) => {

    
    let conteudo;

    if(devolucao){
        conteudo = <Row >
                        <Col span={24}>
                            <Typography.Title style={{ textAlign: "center" }} level={3}>Crédito de Devolução</Typography.Title>
                        </Col>
                        <Col span={24}>
                            <Typography.Title style={{ textAlign: "center" }} level={4}>Num Devolução #{devolucao.numeroDevolucao}</Typography.Title>
                        </Col>
                        <Col span={24}>
                            <Typography.Title style={{ textAlign: "center" }} level={5}>Data Emissão: {moment.utc(devolucao.createdAt, "YYYY-MM-DDTHH:mm:ss").local().format("DD/MM/YYYY HH:mm")} </Typography.Title>
                        </Col>
                        <Col span={24}>
                            <div style={{
                                display: "table",
                                width: "100%"
                            }}>

                                <Typography.Title level={5} style={{ float: "left" }}>Crédito:</Typography.Title>
                                <Typography.Title level={5} style={{ float: "right" }}>
                                    <Dinheiro value={devolucao.valorTotalDevolvido}></Dinheiro>
                                </Typography.Title>

                            </div>

                        </Col>

                    </Row>
    }
   
    return (
        <Impressao margin={{
            right: 5,
            left: 5,
            top: 5
        }} setOpenEvent={setOpenEvent} paperSize={{largura: 80}} >

            {conteudo}
            
        </Impressao>
        
    );
};

export {LayoutImpressaoDevolucao};